import { TableRow, TableHead as TableHeadMaterial } from '@mui/material';
import { memo, useMemo } from 'react';
import { HeadCell } from './types';
import { PmiHeadTableCell } from 'shell/components/shared/table-custom/head';

interface TableHeadProps<T, K extends keyof T> {
  head: Array<HeadCell<T, K>>;
}

interface TableHeadCellProps<T, K extends keyof T> {
  headCell: HeadCell<T, K>;
}

const PmiHeadCellComponent = <T, K extends keyof T>({ headCell }: TableHeadCellProps<T, K>) => {
  return (
    <PmiHeadTableCell key={headCell.id.toString()} colSpan={headCell.colSpan}>
      {headCell.label}
    </PmiHeadTableCell>
  );
};

PmiHeadCellComponent.displayName = 'Pmi head cell component';

const PmiHeadCell = memo(PmiHeadCellComponent) as unknown as typeof PmiHeadCellComponent;

const TableHeadComponent = <T, K extends keyof T>({
  head,
}: TableHeadProps<T, K>): React.ReactElement => {
  const headJsx = useMemo(() => {
    return head.map((headCell) => <PmiHeadCell key={headCell.id.toString()} headCell={headCell} />);
  }, [head]);

  return (
    <TableHeadMaterial>
      <TableRow>{headJsx}</TableRow>
    </TableHeadMaterial>
  );
};

TableHeadComponent.displayName = 'Table Head component';

const TableHead = memo(TableHeadComponent);

export default TableHead as unknown as typeof TableHeadComponent;
